import { useContext, useState } from 'react'

import { Switch } from 'core-components/library/checkbox'
import { Tooltip } from 'core-components/library/tooltip'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'

import { ROUND_TABLE_TRANSLATION_KEYS } from '../../configs/translations'
import { RoundTableContext } from '../../context/RoundTableContext'
import { RoundTableDialogContent } from '../roundTableDialogContent/RoundTableDialogContent'
import { RoundTableText } from '../roundTableText/RoundTableText'

import styles from './RoundTableSwitcher.module.scss'

export const RoundTableSwitcher = ({ withDivider = false }: { withDivider?: boolean }) => {
  const { eligible, ready, disabled, onChange } = useContext(RoundTableContext)
  const [pending, setPending] = useState<boolean | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(false)
  const close = () => {
    if (!busy) {
      setPending(null)
      setError(false)
    }
  }
  const confirm = async () => {
    if (pending === null || busy) return
    setBusy(true)
    setError(false)
    try {
      await onChange(pending)
      setPending(null)
    } catch {
      setError(true)
    } finally {
      setBusy(false)
    }
  }
  if (!eligible) return null
  return (
    <div className={`${styles.switcher} ${withDivider ? styles.withDivider : ''}`}>
      <Switch
        size="sm"
        checked={ready}
        disabled={disabled || busy}
        label={<RoundTableText name="toggle" />}
        onChange={setPending}
      />
      <Tooltip
        tipContent={() => (
          <div className={styles.tip}>
            <RoundTableText name="tip" />
          </div>
        )}
      >
        <span tabIndex={0}>
          <i className="kbase kbase-info" aria-hidden />
        </span>
      </Tooltip>
      <ConfirmationDialog
        windowClassName={styles.dialogWindow}
        size="sm"
        isVisible={pending !== null}
        title={ROUND_TABLE_TRANSLATION_KEYS[pending ? 'addTitle' : 'removeTitle']}
        content={<RoundTableDialogContent adding={pending === true} error={error} />}
        confirmBtnText={ROUND_TABLE_TRANSLATION_KEYS[pending ? 'add' : 'remove']}
        rejectBtnText={ROUND_TABLE_TRANSLATION_KEYS[pending ? 'cancel' : 'keep']}
        isApplyDisabled={busy}
        isApplyNegative={pending === false}
        onConfirm={confirm}
        onReject={close}
      />
    </div>
  )
}
